<template>
<v-app>
<v-main>

    <div
        style="text-align: center; margin-top: 30px; margin-bottom: 30px;"
    >
        <img 
            src="@/assets/redchirp-logo-square-center.png" 
            style="width: 300px"
        />

    </div>

    <div
        style="text-align: center;"
    >
        <h1>Thank you!</h1>
        <br/><br/>
        <h3>Your active payment method has been updated!</h3>
        <br/><br/><br/>
        We appreciate you.
    </div>

</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
</style>